import React, { useState, useEffect } from 'react';

// CSS-in-JS スタイル定義
const styles = {
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: 4000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalContent: {
    background: 'white',
    padding: '20px',
    borderRadius: '10px',
    maxWidth: '90%',
    maxHeight: '90%',
    overflow: 'auto',
    width: '90%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    paddingBottom: '10px',
    borderBottom: '1px solid #ddd'
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#333'
  },
  closeButton: {
    background: 'transparent',
    color: '#666',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    padding: '0',
    width: '30px',
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  doneButton: {
    background: '#F93535',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    padding: '8px 16px',
    cursor: 'pointer',
    fontSize: '14px'
  },
  inputArea: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
    gap: '10px'
  },
  tagInput: {
    flex: 1,
    padding: '12px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '14px',
    outline: 'none'
  },
  addButton: {
    background: '#F93535',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    cursor: 'pointer',
    fontSize: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  tagsArea: {
    minHeight: '200px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    padding: '15px',
    backgroundColor: '#f9f9f9'
  },
  tagItem: {
    display: 'inline-flex',
    alignItems: 'center',
    background: '#e0e0e0',
    color: '#333',
    padding: '6px 12px',
    margin: '4px',
    borderRadius: '20px',
    fontSize: '14px'
  },
  removeButton: {
    background: '#ff4444',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    fontSize: '12px',
    marginLeft: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  noTags: {
    textAlign: 'center',
    color: '#666',
    fontSize: '14px',
    padding: '20px'
  }
};

const ImageTagInputModal = ({ 
  isOpen, 
  onClose, 
  imageIndex,
  currentTags = [],
  onTagsUpdate 
}) => {
  // UI状態
  const [inputValue, setInputValue] = useState(''); // 入力中のタグテキスト
  const [tags, setTags] = useState([]); // タグ一覧

  // モーダル初期化処理
  useEffect(() => {
    if (isOpen) {
      // currentTagsは既にimageTagId順にソートされているので、そのまま使用
      setTags([...currentTags]);
      setInputValue('');
    }
  }, [isOpen, currentTags]);

  // タグ追加処理
  const addTag = () => {
    const trimmedValue = inputValue.trim();
    if (trimmedValue && !tags.includes(trimmedValue)) {
      setTags([...tags, trimmedValue]);
      setInputValue('');
    }
  };

  // タグ削除処理
  const removeTag = (tagToRemove) => {
    setTags(tags.filter(tag => tag !== tagToRemove));
  };

  // キーボード入力処理
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addTag();
    }
  };

  // 完了処理
  const handleDone = () => {
    if (onTagsUpdate) {
      onTagsUpdate(imageIndex, tags);
    }
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={styles.modal}>
      <div style={styles.modalContent}>
        <div style={styles.header}>
          <div style={styles.title}>画像タグ入力</div>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <button style={styles.closeButton} onClick={onClose}>
              ×
            </button>
            <button style={styles.doneButton} onClick={handleDone}>
              完了
            </button>
          </div>
        </div>

        <div style={styles.inputArea}>
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="タグを入力してください"
            style={styles.tagInput}
          />
          <button style={styles.addButton} onClick={addTag}>
            +
          </button>
        </div>

        <div style={styles.tagsArea}>
          {tags.length === 0 ? (
            <div style={styles.noTags}>タグがありません</div>
          ) : (
            tags.map((tag, index) => (
              <div key={index} style={styles.tagItem}>
                {tag}
                <button 
                  style={styles.removeButton}
                  onClick={() => removeTag(tag)}
                >
                  ×
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageTagInputModal;
